// source: projects/erp/service/api/v1/model/property.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var projects_erp_service_api_v1_model_list_of_strings_pb = require('../list_of_strings_pb.js');
goog.object.extend(proto, projects_erp_service_api_v1_model_list_of_strings_pb);
var projects_erp_service_api_v1_model_money_pb = require('../money_pb.js');
goog.object.extend(proto, projects_erp_service_api_v1_model_money_pb);
var projects_erp_service_api_v1_model_unit_pb = require('../unit_pb.js');
goog.object.extend(proto, projects_erp_service_api_v1_model_unit_pb);
goog.exportSymbol('proto.qowner.erp.api.v1.model.Property', null, global);
goog.exportSymbol('proto.qowner.erp.api.v1.model.PropertyLocation', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.qowner.erp.api.v1.model.Property = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.qowner.erp.api.v1.model.Property.repeatedFields_, null);
};
goog.inherits(proto.qowner.erp.api.v1.model.Property, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.qowner.erp.api.v1.model.Property.displayName = 'proto.qowner.erp.api.v1.model.Property';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.qowner.erp.api.v1.model.PropertyLocation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.qowner.erp.api.v1.model.PropertyLocation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.qowner.erp.api.v1.model.PropertyLocation.displayName = 'proto.qowner.erp.api.v1.model.PropertyLocation';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.qowner.erp.api.v1.model.Property.repeatedFields_ = [30,41];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.qowner.erp.api.v1.model.Property.prototype.toObject = function(opt_includeInstance) {
  return proto.qowner.erp.api.v1.model.Property.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.qowner.erp.api.v1.model.Property} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.qowner.erp.api.v1.model.Property.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0),
    number: jspb.Message.getFieldWithDefault(msg, 3, ""),
    displayName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    developerName: (f = msg.getDeveloperName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    projectName: (f = msg.getProjectName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    projectDisplayName: (f = msg.getProjectDisplayName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    description: (f = msg.getDescription()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    externalNumber: (f = msg.getExternalNumber()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    externalSystem: (f = msg.getExternalSystem()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    externalUrl: (f = msg.getExternalUrl()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    isProject: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    isFeatured: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
    typeName: jspb.Message.getFieldWithDefault(msg, 14, ""),
    forSale: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
    forRent: jspb.Message.getBooleanFieldWithDefault(msg, 16, false),
    statusName: jspb.Message.getFieldWithDefault(msg, 17, ""),
    amount: (f = msg.getAmount()) && projects_erp_service_api_v1_model_money_pb.Money.toObject(includeInstance, f),
    vat: jspb.Message.getBooleanFieldWithDefault(msg, 19, false),
    dailyRent: (f = msg.getDailyRent()) && projects_erp_service_api_v1_model_money_pb.Money.toObject(includeInstance, f),
    monthlyRent: (f = msg.getMonthlyRent()) && projects_erp_service_api_v1_model_money_pb.Money.toObject(includeInstance, f),
    estimatedMonthlyRent: (f = msg.getEstimatedMonthlyRent()) && projects_erp_service_api_v1_model_money_pb.Money.toObject(includeInstance, f),
    location: (f = msg.getLocation()) && proto.qowner.erp.api.v1.model.PropertyLocation.toObject(includeInstance, f),
    valuesMap: (f = msg.getValuesMap()) ? f.toObject(includeInstance, undefined) : [],
    amenitiesMap: (f = msg.getAmenitiesMap()) ? f.toObject(includeInstance, undefined) : [],
    unitsMap: (f = msg.getUnitsMap()) ? f.toObject(includeInstance, proto.qowner.erp.api.v1.model.Unit.toObject) : [],
    photosMap: (f = msg.getPhotosMap()) ? f.toObject(includeInstance, proto.qowner.erp.api.v1.model.ListOfStrings.toObject) : [],
    mainPhoto: (f = msg.getMainPhoto()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    project: (f = msg.getProject()) && proto.qowner.erp.api.v1.model.Property.toObject(includeInstance, f),
    supportedTypeNamesList: (f = jspb.Message.getRepeatedField(msg, 30)) == null ? undefined : f,
    unitCount: jspb.Message.getFieldWithDefault(msg, 31, 0),
    isVerified: jspb.Message.getBooleanFieldWithDefault(msg, 32, false),
    isUpdated: jspb.Message.getBooleanFieldWithDefault(msg, 33, false),
    paymentPlanDescription: (f = msg.getPaymentPlanDescription()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    note: (f = msg.getNote()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    publicDescription: (f = msg.getPublicDescription()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    hasCoownership: jspb.Message.getBooleanFieldWithDefault(msg, 37, false),
    hoaMonthlyFee: (f = msg.getHoaMonthlyFee()) && projects_erp_service_api_v1_model_money_pb.Money.toObject(includeInstance, f),
    reservedShared: jspb.Message.getFieldWithDefault(msg, 39, 0),
    upgradeCost: (f = msg.getUpgradeCost()) && projects_erp_service_api_v1_model_money_pb.Money.toObject(includeInstance, f),
    coownershipDocumentsList: (f = jspb.Message.getRepeatedField(msg, 41)) == null ? undefined : f,
    agency: (f = msg.getAgency()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    publicationAt: (f = msg.getPublicationAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    validationAt: (f = msg.getValidationAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.qowner.erp.api.v1.model.Property}
 */
proto.qowner.erp.api.v1.model.Property.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.qowner.erp.api.v1.model.Property;
  return proto.qowner.erp.api.v1.model.Property.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.qowner.erp.api.v1.model.Property} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.qowner.erp.api.v1.model.Property}
 */
proto.qowner.erp.api.v1.model.Property.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNumber(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDeveloperName(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setProjectName(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setProjectDisplayName(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDescription(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setExternalNumber(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setExternalSystem(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setExternalUrl(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsProject(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsFeatured(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setTypeName(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setForSale(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setForRent(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusName(value);
      break;
    case 18:
      var value = new projects_erp_service_api_v1_model_money_pb.Money;
      reader.readMessage(value,projects_erp_service_api_v1_model_money_pb.Money.deserializeBinaryFromReader);
      msg.setAmount(value);
      break;
    case 19:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVat(value);
      break;
    case 20:
      var value = new projects_erp_service_api_v1_model_money_pb.Money;
      reader.readMessage(value,projects_erp_service_api_v1_model_money_pb.Money.deserializeBinaryFromReader);
      msg.setDailyRent(value);
      break;
    case 21:
      var value = new projects_erp_service_api_v1_model_money_pb.Money;
      reader.readMessage(value,projects_erp_service_api_v1_model_money_pb.Money.deserializeBinaryFromReader);
      msg.setMonthlyRent(value);
      break;
    case 22:
      var value = new projects_erp_service_api_v1_model_money_pb.Money;
      reader.readMessage(value,projects_erp_service_api_v1_model_money_pb.Money.deserializeBinaryFromReader);
      msg.setEstimatedMonthlyRent(value);
      break;
    case 23:
      var value = new proto.qowner.erp.api.v1.model.PropertyLocation;
      reader.readMessage(value,proto.qowner.erp.api.v1.model.PropertyLocation.deserializeBinaryFromReader);
      msg.setLocation(value);
      break;
    case 24:
      var value = msg.getValuesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 25:
      var value = msg.getAmenitiesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 26:
      var value = msg.getUnitsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.qowner.erp.api.v1.model.Unit.deserializeBinaryFromReader, "", new proto.qowner.erp.api.v1.model.Unit());
         });
      break;
    case 27:
      var value = msg.getPhotosMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.qowner.erp.api.v1.model.ListOfStrings.deserializeBinaryFromReader, "", new proto.qowner.erp.api.v1.model.ListOfStrings());
         });
      break;
    case 28:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setMainPhoto(value);
      break;
    case 29:
      var value = new proto.qowner.erp.api.v1.model.Property;
      reader.readMessage(value,proto.qowner.erp.api.v1.model.Property.deserializeBinaryFromReader);
      msg.setProject(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.addSupportedTypeNames(value);
      break;
    case 31:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUnitCount(value);
      break;
    case 32:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsVerified(value);
      break;
    case 33:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsUpdated(value);
      break;
    case 34:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPaymentPlanDescription(value);
      break;
    case 35:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setNote(value);
      break;
    case 36:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPublicDescription(value);
      break;
    case 37:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasCoownership(value);
      break;
    case 38:
      var value = new projects_erp_service_api_v1_model_money_pb.Money;
      reader.readMessage(value,projects_erp_service_api_v1_model_money_pb.Money.deserializeBinaryFromReader);
      msg.setHoaMonthlyFee(value);
      break;
    case 39:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setReservedShared(value);
      break;
    case 40:
      var value = new projects_erp_service_api_v1_model_money_pb.Money;
      reader.readMessage(value,projects_erp_service_api_v1_model_money_pb.Money.deserializeBinaryFromReader);
      msg.setUpgradeCost(value);
      break;
    case 41:
      var value = /** @type {string} */ (reader.readString());
      msg.addCoownershipDocuments(value);
      break;
    case 42:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAgency(value);
      break;
    case 43:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPublicationAt(value);
      break;
    case 44:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setValidationAt(value);
      break;
    case 45:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 46:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.qowner.erp.api.v1.model.Property.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.qowner.erp.api.v1.model.Property.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.qowner.erp.api.v1.model.Property} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.qowner.erp.api.v1.model.Property.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getNumber();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDeveloperName();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getProjectName();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getProjectDisplayName();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getDescription();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getExternalNumber();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getExternalSystem();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getExternalUrl();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getIsProject();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getIsFeatured();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getTypeName();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getForSale();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getForRent();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
  f = message.getStatusName();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getAmount();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      projects_erp_service_api_v1_model_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getVat();
  if (f) {
    writer.writeBool(
      19,
      f
    );
  }
  f = message.getDailyRent();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      projects_erp_service_api_v1_model_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getMonthlyRent();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      projects_erp_service_api_v1_model_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getEstimatedMonthlyRent();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      projects_erp_service_api_v1_model_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getLocation();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      proto.qowner.erp.api.v1.model.PropertyLocation.serializeBinaryToWriter
    );
  }
  f = message.getValuesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(24, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getAmenitiesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(25, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getUnitsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(26, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.qowner.erp.api.v1.model.Unit.serializeBinaryToWriter);
  }
  f = message.getPhotosMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(27, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.qowner.erp.api.v1.model.ListOfStrings.serializeBinaryToWriter);
  }
  f = message.getMainPhoto();
  if (f != null) {
    writer.writeMessage(
      28,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getProject();
  if (f != null) {
    writer.writeMessage(
      29,
      f,
      proto.qowner.erp.api.v1.model.Property.serializeBinaryToWriter
    );
  }
  f = message.getSupportedTypeNamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      30,
      f
    );
  }
  f = message.getUnitCount();
  if (f !== 0) {
    writer.writeUint32(
      31,
      f
    );
  }
  f = message.getIsVerified();
  if (f) {
    writer.writeBool(
      32,
      f
    );
  }
  f = message.getIsUpdated();
  if (f) {
    writer.writeBool(
      33,
      f
    );
  }
  f = message.getPaymentPlanDescription();
  if (f != null) {
    writer.writeMessage(
      34,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getNote();
  if (f != null) {
    writer.writeMessage(
      35,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPublicDescription();
  if (f != null) {
    writer.writeMessage(
      36,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getHasCoownership();
  if (f) {
    writer.writeBool(
      37,
      f
    );
  }
  f = message.getHoaMonthlyFee();
  if (f != null) {
    writer.writeMessage(
      38,
      f,
      projects_erp_service_api_v1_model_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getReservedShared();
  if (f !== 0) {
    writer.writeUint32(
      39,
      f
    );
  }
  f = message.getUpgradeCost();
  if (f != null) {
    writer.writeMessage(
      40,
      f,
      projects_erp_service_api_v1_model_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getCoownershipDocumentsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      41,
      f
    );
  }
  f = message.getAgency();
  if (f != null) {
    writer.writeMessage(
      42,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPublicationAt();
  if (f != null) {
    writer.writeMessage(
      43,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getValidationAt();
  if (f != null) {
    writer.writeMessage(
      44,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      45,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      46,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 id = 2;
 * @return {number}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string number = 3;
 * @return {string}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.setNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string display_name = 4;
 * @return {string}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.StringValue developer_name = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getDeveloperName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
*/
proto.qowner.erp.api.v1.model.Property.prototype.setDeveloperName = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.clearDeveloperName = function() {
  return this.setDeveloperName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.Property.prototype.hasDeveloperName = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.StringValue project_name = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getProjectName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
*/
proto.qowner.erp.api.v1.model.Property.prototype.setProjectName = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.clearProjectName = function() {
  return this.setProjectName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.Property.prototype.hasProjectName = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.StringValue project_display_name = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getProjectDisplayName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
*/
proto.qowner.erp.api.v1.model.Property.prototype.setProjectDisplayName = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.clearProjectDisplayName = function() {
  return this.setProjectDisplayName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.Property.prototype.hasProjectDisplayName = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.StringValue description = 8;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getDescription = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 8));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
*/
proto.qowner.erp.api.v1.model.Property.prototype.setDescription = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.clearDescription = function() {
  return this.setDescription(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.Property.prototype.hasDescription = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.StringValue external_number = 9;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getExternalNumber = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 9));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
*/
proto.qowner.erp.api.v1.model.Property.prototype.setExternalNumber = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.clearExternalNumber = function() {
  return this.setExternalNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.Property.prototype.hasExternalNumber = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.StringValue external_system = 10;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getExternalSystem = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 10));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
*/
proto.qowner.erp.api.v1.model.Property.prototype.setExternalSystem = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.clearExternalSystem = function() {
  return this.setExternalSystem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.Property.prototype.hasExternalSystem = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.StringValue external_url = 11;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getExternalUrl = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 11));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
*/
proto.qowner.erp.api.v1.model.Property.prototype.setExternalUrl = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.clearExternalUrl = function() {
  return this.setExternalUrl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.Property.prototype.hasExternalUrl = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional bool is_project = 12;
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getIsProject = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.setIsProject = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional bool is_featured = 13;
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getIsFeatured = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.setIsFeatured = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional string type_name = 14;
 * @return {string}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getTypeName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.setTypeName = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional bool for_sale = 15;
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getForSale = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.setForSale = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional bool for_rent = 16;
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getForRent = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.setForRent = function(value) {
  return jspb.Message.setProto3BooleanField(this, 16, value);
};


/**
 * optional string status_name = 17;
 * @return {string}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getStatusName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.setStatusName = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional Money amount = 18;
 * @return {?proto.qowner.erp.api.v1.model.Money}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getAmount = function() {
  return /** @type{?proto.qowner.erp.api.v1.model.Money} */ (
    jspb.Message.getWrapperField(this, projects_erp_service_api_v1_model_money_pb.Money, 18));
};


/**
 * @param {?proto.qowner.erp.api.v1.model.Money|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
*/
proto.qowner.erp.api.v1.model.Property.prototype.setAmount = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.clearAmount = function() {
  return this.setAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.Property.prototype.hasAmount = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional bool vat = 19;
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getVat = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 19, false));
};


/**
 * @param {boolean} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.setVat = function(value) {
  return jspb.Message.setProto3BooleanField(this, 19, value);
};


/**
 * optional Money daily_rent = 20;
 * @return {?proto.qowner.erp.api.v1.model.Money}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getDailyRent = function() {
  return /** @type{?proto.qowner.erp.api.v1.model.Money} */ (
    jspb.Message.getWrapperField(this, projects_erp_service_api_v1_model_money_pb.Money, 20));
};


/**
 * @param {?proto.qowner.erp.api.v1.model.Money|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
*/
proto.qowner.erp.api.v1.model.Property.prototype.setDailyRent = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.clearDailyRent = function() {
  return this.setDailyRent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.Property.prototype.hasDailyRent = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional Money monthly_rent = 21;
 * @return {?proto.qowner.erp.api.v1.model.Money}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getMonthlyRent = function() {
  return /** @type{?proto.qowner.erp.api.v1.model.Money} */ (
    jspb.Message.getWrapperField(this, projects_erp_service_api_v1_model_money_pb.Money, 21));
};


/**
 * @param {?proto.qowner.erp.api.v1.model.Money|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
*/
proto.qowner.erp.api.v1.model.Property.prototype.setMonthlyRent = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.clearMonthlyRent = function() {
  return this.setMonthlyRent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.Property.prototype.hasMonthlyRent = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional Money estimated_monthly_rent = 22;
 * @return {?proto.qowner.erp.api.v1.model.Money}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getEstimatedMonthlyRent = function() {
  return /** @type{?proto.qowner.erp.api.v1.model.Money} */ (
    jspb.Message.getWrapperField(this, projects_erp_service_api_v1_model_money_pb.Money, 22));
};


/**
 * @param {?proto.qowner.erp.api.v1.model.Money|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
*/
proto.qowner.erp.api.v1.model.Property.prototype.setEstimatedMonthlyRent = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.clearEstimatedMonthlyRent = function() {
  return this.setEstimatedMonthlyRent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.Property.prototype.hasEstimatedMonthlyRent = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional PropertyLocation location = 23;
 * @return {?proto.qowner.erp.api.v1.model.PropertyLocation}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getLocation = function() {
  return /** @type{?proto.qowner.erp.api.v1.model.PropertyLocation} */ (
    jspb.Message.getWrapperField(this, proto.qowner.erp.api.v1.model.PropertyLocation, 23));
};


/**
 * @param {?proto.qowner.erp.api.v1.model.PropertyLocation|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
*/
proto.qowner.erp.api.v1.model.Property.prototype.setLocation = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.clearLocation = function() {
  return this.setLocation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.Property.prototype.hasLocation = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * map<string, string> values = 24;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getValuesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 24, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.clearValuesMap = function() {
  this.getValuesMap().clear();
  return this;};


/**
 * map<string, string> amenities = 25;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getAmenitiesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 25, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.clearAmenitiesMap = function() {
  this.getAmenitiesMap().clear();
  return this;};


/**
 * map<string, Unit> units = 26;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.qowner.erp.api.v1.model.Unit>}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getUnitsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.qowner.erp.api.v1.model.Unit>} */ (
      jspb.Message.getMapField(this, 26, opt_noLazyCreate,
      proto.qowner.erp.api.v1.model.Unit));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.clearUnitsMap = function() {
  this.getUnitsMap().clear();
  return this;};


/**
 * map<string, ListOfStrings> photos = 27;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.qowner.erp.api.v1.model.ListOfStrings>}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getPhotosMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.qowner.erp.api.v1.model.ListOfStrings>} */ (
      jspb.Message.getMapField(this, 27, opt_noLazyCreate,
      proto.qowner.erp.api.v1.model.ListOfStrings));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.clearPhotosMap = function() {
  this.getPhotosMap().clear();
  return this;};


/**
 * optional google.protobuf.StringValue main_photo = 28;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getMainPhoto = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 28));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
*/
proto.qowner.erp.api.v1.model.Property.prototype.setMainPhoto = function(value) {
  return jspb.Message.setWrapperField(this, 28, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.clearMainPhoto = function() {
  return this.setMainPhoto(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.Property.prototype.hasMainPhoto = function() {
  return jspb.Message.getField(this, 28) != null;
};


/**
 * optional Property project = 29;
 * @return {?proto.qowner.erp.api.v1.model.Property}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getProject = function() {
  return /** @type{?proto.qowner.erp.api.v1.model.Property} */ (
    jspb.Message.getWrapperField(this, proto.qowner.erp.api.v1.model.Property, 29));
};


/**
 * @param {?proto.qowner.erp.api.v1.model.Property|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
*/
proto.qowner.erp.api.v1.model.Property.prototype.setProject = function(value) {
  return jspb.Message.setWrapperField(this, 29, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.clearProject = function() {
  return this.setProject(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.Property.prototype.hasProject = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * repeated string supported_type_names = 30;
 * @return {!Array<string>}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getSupportedTypeNamesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 30));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.setSupportedTypeNamesList = function(value) {
  return jspb.Message.setField(this, 30, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.addSupportedTypeNames = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 30, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.clearSupportedTypeNamesList = function() {
  return this.setSupportedTypeNamesList([]);
};


/**
 * optional uint32 unit_count = 31;
 * @return {number}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getUnitCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 31, 0));
};


/**
 * @param {number} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.setUnitCount = function(value) {
  return jspb.Message.setProto3IntField(this, 31, value);
};


/**
 * optional bool is_verified = 32;
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getIsVerified = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 32, false));
};


/**
 * @param {boolean} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.setIsVerified = function(value) {
  return jspb.Message.setProto3BooleanField(this, 32, value);
};


/**
 * optional bool is_updated = 33;
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getIsUpdated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 33, false));
};


/**
 * @param {boolean} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.setIsUpdated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 33, value);
};


/**
 * optional google.protobuf.StringValue payment_plan_description = 34;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getPaymentPlanDescription = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 34));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
*/
proto.qowner.erp.api.v1.model.Property.prototype.setPaymentPlanDescription = function(value) {
  return jspb.Message.setWrapperField(this, 34, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.clearPaymentPlanDescription = function() {
  return this.setPaymentPlanDescription(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.Property.prototype.hasPaymentPlanDescription = function() {
  return jspb.Message.getField(this, 34) != null;
};


/**
 * optional google.protobuf.StringValue note = 35;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getNote = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 35));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
*/
proto.qowner.erp.api.v1.model.Property.prototype.setNote = function(value) {
  return jspb.Message.setWrapperField(this, 35, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.clearNote = function() {
  return this.setNote(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.Property.prototype.hasNote = function() {
  return jspb.Message.getField(this, 35) != null;
};


/**
 * optional google.protobuf.StringValue public_description = 36;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getPublicDescription = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 36));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
*/
proto.qowner.erp.api.v1.model.Property.prototype.setPublicDescription = function(value) {
  return jspb.Message.setWrapperField(this, 36, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.clearPublicDescription = function() {
  return this.setPublicDescription(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.Property.prototype.hasPublicDescription = function() {
  return jspb.Message.getField(this, 36) != null;
};


/**
 * optional bool has_coownership = 37;
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getHasCoownership = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 37, false));
};


/**
 * @param {boolean} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.setHasCoownership = function(value) {
  return jspb.Message.setProto3BooleanField(this, 37, value);
};


/**
 * optional Money hoa_monthly_fee = 38;
 * @return {?proto.qowner.erp.api.v1.model.Money}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getHoaMonthlyFee = function() {
  return /** @type{?proto.qowner.erp.api.v1.model.Money} */ (
    jspb.Message.getWrapperField(this, projects_erp_service_api_v1_model_money_pb.Money, 38));
};


/**
 * @param {?proto.qowner.erp.api.v1.model.Money|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
*/
proto.qowner.erp.api.v1.model.Property.prototype.setHoaMonthlyFee = function(value) {
  return jspb.Message.setWrapperField(this, 38, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.clearHoaMonthlyFee = function() {
  return this.setHoaMonthlyFee(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.Property.prototype.hasHoaMonthlyFee = function() {
  return jspb.Message.getField(this, 38) != null;
};


/**
 * optional uint32 reserved_shared = 39;
 * @return {number}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getReservedShared = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 39, 0));
};


/**
 * @param {number} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.setReservedShared = function(value) {
  return jspb.Message.setProto3IntField(this, 39, value);
};


/**
 * optional Money upgrade_cost = 40;
 * @return {?proto.qowner.erp.api.v1.model.Money}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getUpgradeCost = function() {
  return /** @type{?proto.qowner.erp.api.v1.model.Money} */ (
    jspb.Message.getWrapperField(this, projects_erp_service_api_v1_model_money_pb.Money, 40));
};


/**
 * @param {?proto.qowner.erp.api.v1.model.Money|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
*/
proto.qowner.erp.api.v1.model.Property.prototype.setUpgradeCost = function(value) {
  return jspb.Message.setWrapperField(this, 40, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.clearUpgradeCost = function() {
  return this.setUpgradeCost(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.Property.prototype.hasUpgradeCost = function() {
  return jspb.Message.getField(this, 40) != null;
};


/**
 * repeated string coownership_documents = 41;
 * @return {!Array<string>}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getCoownershipDocumentsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 41));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.setCoownershipDocumentsList = function(value) {
  return jspb.Message.setField(this, 41, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.addCoownershipDocuments = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 41, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.clearCoownershipDocumentsList = function() {
  return this.setCoownershipDocumentsList([]);
};


/**
 * optional google.protobuf.StringValue agency = 42;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getAgency = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 42));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
*/
proto.qowner.erp.api.v1.model.Property.prototype.setAgency = function(value) {
  return jspb.Message.setWrapperField(this, 42, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.clearAgency = function() {
  return this.setAgency(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.Property.prototype.hasAgency = function() {
  return jspb.Message.getField(this, 42) != null;
};


/**
 * optional google.protobuf.Timestamp publication_at = 43;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getPublicationAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 43));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
*/
proto.qowner.erp.api.v1.model.Property.prototype.setPublicationAt = function(value) {
  return jspb.Message.setWrapperField(this, 43, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.clearPublicationAt = function() {
  return this.setPublicationAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.Property.prototype.hasPublicationAt = function() {
  return jspb.Message.getField(this, 43) != null;
};


/**
 * optional google.protobuf.Timestamp validation_at = 44;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getValidationAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 44));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
*/
proto.qowner.erp.api.v1.model.Property.prototype.setValidationAt = function(value) {
  return jspb.Message.setWrapperField(this, 44, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.clearValidationAt = function() {
  return this.setValidationAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.Property.prototype.hasValidationAt = function() {
  return jspb.Message.getField(this, 44) != null;
};


/**
 * optional google.protobuf.Timestamp created_at = 45;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 45));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
*/
proto.qowner.erp.api.v1.model.Property.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 45, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.Property.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 45) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 46;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.qowner.erp.api.v1.model.Property.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 46));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
*/
proto.qowner.erp.api.v1.model.Property.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 46, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.Property} returns this
 */
proto.qowner.erp.api.v1.model.Property.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.Property.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 46) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.toObject = function(opt_includeInstance) {
  return proto.qowner.erp.api.v1.model.PropertyLocation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.qowner.erp.api.v1.model.PropertyLocation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.qowner.erp.api.v1.model.PropertyLocation.toObject = function(includeInstance, msg) {
  var f, obj = {
    countryName: (f = msg.getCountryName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    stateName: (f = msg.getStateName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    cityName: (f = msg.getCityName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    zip: (f = msg.getZip()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    addressLine1: (f = msg.getAddressLine1()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    addressLine2: (f = msg.getAddressLine2()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    appartment: (f = msg.getAppartment()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    districtName: (f = msg.getDistrictName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    settlementName: (f = msg.getSettlementName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    quarterName: (f = msg.getQuarterName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    latitude: (f = msg.getLatitude()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
    longitude: (f = msg.getLongitude()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.qowner.erp.api.v1.model.PropertyLocation}
 */
proto.qowner.erp.api.v1.model.PropertyLocation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.qowner.erp.api.v1.model.PropertyLocation;
  return proto.qowner.erp.api.v1.model.PropertyLocation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.qowner.erp.api.v1.model.PropertyLocation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.qowner.erp.api.v1.model.PropertyLocation}
 */
proto.qowner.erp.api.v1.model.PropertyLocation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCountryName(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setStateName(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCityName(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setZip(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAddressLine1(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAddressLine2(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAppartment(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDistrictName(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSettlementName(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setQuarterName(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setLatitude(value);
      break;
    case 12:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setLongitude(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.qowner.erp.api.v1.model.PropertyLocation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.qowner.erp.api.v1.model.PropertyLocation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.qowner.erp.api.v1.model.PropertyLocation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCountryName();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getStateName();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCityName();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getZip();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getAddressLine1();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getAddressLine2();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getAppartment();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getDistrictName();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSettlementName();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getQuarterName();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getLatitude();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getLongitude();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue country_name = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.getCountryName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.PropertyLocation} returns this
*/
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.setCountryName = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.PropertyLocation} returns this
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.clearCountryName = function() {
  return this.setCountryName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.hasCountryName = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue state_name = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.getStateName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.PropertyLocation} returns this
*/
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.setStateName = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.PropertyLocation} returns this
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.clearStateName = function() {
  return this.setStateName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.hasStateName = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue city_name = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.getCityName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.PropertyLocation} returns this
*/
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.setCityName = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.PropertyLocation} returns this
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.clearCityName = function() {
  return this.setCityName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.hasCityName = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue zip = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.getZip = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.PropertyLocation} returns this
*/
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.setZip = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.PropertyLocation} returns this
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.clearZip = function() {
  return this.setZip(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.hasZip = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue address_line1 = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.getAddressLine1 = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.PropertyLocation} returns this
*/
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.setAddressLine1 = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.PropertyLocation} returns this
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.clearAddressLine1 = function() {
  return this.setAddressLine1(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.hasAddressLine1 = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.StringValue address_line2 = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.getAddressLine2 = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.PropertyLocation} returns this
*/
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.setAddressLine2 = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.PropertyLocation} returns this
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.clearAddressLine2 = function() {
  return this.setAddressLine2(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.hasAddressLine2 = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.StringValue appartment = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.getAppartment = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.PropertyLocation} returns this
*/
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.setAppartment = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.PropertyLocation} returns this
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.clearAppartment = function() {
  return this.setAppartment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.hasAppartment = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.StringValue district_name = 8;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.getDistrictName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 8));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.PropertyLocation} returns this
*/
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.setDistrictName = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.PropertyLocation} returns this
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.clearDistrictName = function() {
  return this.setDistrictName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.hasDistrictName = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.StringValue settlement_name = 9;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.getSettlementName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 9));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.PropertyLocation} returns this
*/
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.setSettlementName = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.PropertyLocation} returns this
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.clearSettlementName = function() {
  return this.setSettlementName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.hasSettlementName = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.StringValue quarter_name = 10;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.getQuarterName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 10));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.PropertyLocation} returns this
*/
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.setQuarterName = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.PropertyLocation} returns this
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.clearQuarterName = function() {
  return this.setQuarterName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.hasQuarterName = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.DoubleValue latitude = 11;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.getLatitude = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 11));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.PropertyLocation} returns this
*/
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.setLatitude = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.PropertyLocation} returns this
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.clearLatitude = function() {
  return this.setLatitude(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.hasLatitude = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.DoubleValue longitude = 12;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.getLongitude = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 12));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.PropertyLocation} returns this
*/
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.setLongitude = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.PropertyLocation} returns this
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.clearLongitude = function() {
  return this.setLongitude(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.PropertyLocation.prototype.hasLongitude = function() {
  return jspb.Message.getField(this, 12) != null;
};


goog.object.extend(exports, proto.qowner.erp.api.v1.model);
